import React from 'preact/compat';
import { useMemo } from 'preact/hooks';
import { useServicesParam } from '../../state/parameterStore.js'
import { toggleValue } from '../../state/utils.js'
import Box from '@mui/material/Box';

import colors from '../colors';
import Loading from '../Loading';
import LauncherFeatureStack from './LauncherFeatureStack';

// Create global properties and use them to prevent unnecessary re-rendering
let serviceCallback;

const LauncherFeatureSelector = () => {
    const [selectedServices, setSelectedServices, services, servicesLoading] = useServicesParam();

    serviceCallback = (value) => {
        setSelectedServices(toggleValue(selectedServices, value));
    }

    const basicServices = useMemo(() => {
        return services && services.filter(service => service.name !== "SDK");
    }, [services]);

    const handleServiceClick = useMemo(() => (value) => serviceCallback(value), []);

    return (
        <Box
            sx={{
                borderWidth: "1px",
                borderStyle: "solid",
                borderColor: colors.featureSelectorBorder,
                borderRadius: '8px',
                backgroundColor: colors.featureSelectorBackground,
                overflow: 'hidden',
                marginTop: '65px',
                marginBottom: '40px',
                paddingBottom: '60px'
            }}
        >
            { servicesLoading &&
                <Loading />
            }

            { !servicesLoading &&
                <LauncherFeatureStack features={basicServices} selectedFeatures={selectedServices} title="Cloud Services"
                    onClick={handleServiceClick} doShowServices largeTitle />
            }
        </Box>
    )
}

export default LauncherFeatureSelector;
